.rootPadding {
  background-color: transparent;
}
.root {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 1fr;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #161a2133;
  // padding-left: 100px;
  // padding-right: 100px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 15;
  transition: 0.3s ease all;
  height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #f8f7f4;

  // position: absolute;
  top: 0;
  left: 0;
  right: 0;
  .navItem {
    position: relative;
    background: transparent;
    border: none;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.02em;
    // text-align: left;
    text-transform: uppercase;
    color: #000;
    cursor: pointer;
    transition: 0.3s ease all;
    display: flex;
    justify-content: center;
    align-items: stretch;
    padding: 0;
    > span {
      //item inner
      display: flex;
      align-items: center;
    }
    .cartIcon {
      width: 14px;
      height: 18px;
      transform: translateY(-1px);
    }
    .searchIcon {
      width: 18px;
      height: 18px;
    }
    .hlIcon {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      transform: translateY(1px);
      width: 100%;
    }
    .cartActiveDot {
      position: absolute;
      transform: translateY(-12px) translateX(7px);
      transition: 0.3s ease all;
      background: #000;
      color: #fff;
      font-size: 11px;
      width: 18px;
      height: 18px;
      display: flex;
      border-radius: 1000px;
      justify-content: center;
      align-items: center;
    }
  }
  .navItemDesktop {
    @extend .navItem;
    display: none;
    .cartActiveDot {
      transform: translateY(-35px) translateX(12px);
    }
  }
  .leftArea {
    display: grid;
    justify-content: flex-start;
    grid-template-columns: repeat(3, auto);
    grid-template-rows: 1fr;
    column-gap: 50px;
    height: 100%;
    .menuButton {
      background-color: transparent;
      border: none;
      .menuIcon {
        color: #000;
        height: 18px;
        width: 24px;
      }
    }
  }
  .leftAreaDesktop {
    @extend .leftArea;
    display: none;
  }

  .logoArea {
    cursor: pointer;
    .logo {
      // filter: invert(1);
      height: 36px;
    }
  }
  .rightArea {
    display: grid;
    justify-content: flex-end;
    grid-template-columns: repeat(2, auto);
    height: 100%;
    gap: 20px;
  }
  .rightAreaDesktop {
    @extend .rightArea;
    display: none;
  }
  &.menuActive,
  &:hover {
    background-color: #f8f7f4;
    border-bottom: 1px solid #161a2133;
    .navItem {
      color: #161a21;
      .cartActiveDot {
      }
    }
    .leftArea {
      .menuIcon {
        color: #161a21;
      }
    }
    .logoArea {
      .logo {
        filter: invert(0);
      }
    }
  }
  &.menuScrolled {
    position: fixed;
    background-color: #f8f7f4;
    border-bottom: 1px solid #161a2133;
    .navItem {
      color: #161a21;
    }
    .leftArea {
      .menuButton {
        .menuIcon {
          color: #161a21;
        }
      }
    }
    .logoArea {
      .logo {
        filter: invert(0);
      }
    }
  }
}

//menu item
.aboutMenu {
  background: #f8f7f4 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-top: 1px solid rgba(22, 26, 33, 0.2) !important;
  .aboutMenuItem {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.02em;
    text-align: center;
    color: #161a2163;
    justify-content: center;
    padding-bottom: 10px;
    padding-top: 10px;
    &:first-child {
      margin-top: 22px;
    }
    &:last-child {
      margin-bottom: 22px;
    }
    .aboutMenuItemLink {
      font-family: Montserrat, san-serif;
      text-decoration: none;
      color: #161a2163;
    }
  }
}

@media (min-width: 768px) {
  .root {
    height: 80px;

    .navItem {
      display: none;
    }
    .navItemDesktop {
      display: flex;
      .cartActiveDot {
      }
    }
    .leftArea {
      display: none;
      .menuButton {
        .menuIcon {
          display: none;
        }
      }
    }
    .leftAreaDesktop {
      display: grid;
      column-gap: 50px;
    }
    .logoArea {
      .logo {
        height: 48px;
      }
    }
    .rightArea {
      display: none;
    }
    .rightAreaDesktop {
      display: grid;
      column-gap: 50px;
      grid-template-columns: repeat(3, auto);
    }
  }
}

@media (min-width: 1280px) {
  .root {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 1366px) {
  .root {
    padding-left: 50px;
    padding-right: 50px;
  }
}
@media (min-width: 1440px) {
  .root {
    padding-left: 100px;
    padding-right: 100px;
  }
}

.maskRoot {
  top: 80px !important;
  // background-color: transparent !important;
  border: none;
}

.rootInverted {
  filter: invert(1);
  &:hover {
    filter: invert(0);
  }
}
.menuActive {
  filter: invert(0);
}
